import { Icon } from "@core/components";
import { usePdfTranslate } from "@modules/viewers/pdf/hooks/usePdfTranslate";

export function PdfErrorState() {
  const { t } = usePdfTranslate();

  return (
    <div className="flex flex-col items-center justify-center w-full h-full gap-3 text-neutral-400">
      <Icon name="file" className="w-10 h-10" />
      <span className="text-sm">{t("error")}</span>
    </div>
  );
}
